/**
 * 生成歷史圖片清單的純判斷邏輯。
 * 抽成純函式是為了讓「已刪除的圖片不可被選取」「還原時預設選取使用者點的那張」
 * 這兩條規則能被單元測試守住，元件層只剩下 JSX。
 */

export interface HistoryEntryLike {
  fileId?: string;
  /** 該位置的圖片已被使用者刪除，僅保留佔位格 */
  deleted?: boolean;
}

/**
 * 能否選取指定位置的圖片。
 * 已刪除的佔位格不可選取（也因此不可下載）；佔位格本身仍佔著原本的索引，順序不位移。
 */
export function canSelectHistoryImage(history: HistoryEntryLike[], index: number): boolean {
  if (index < 0 || index >= history.length) return false;
  return !history[index]?.deleted;
}

/**
 * 還原時預設要選取的位置：使用者在圖片庫點的那張。
 * 找不到（例如剛好被刪掉）時退回最後一張可選取的圖片，全都不可選取時回 -1。
 */
export function resolveInitialHistoryIndex(
  history: HistoryEntryLike[],
  focusFileId?: string
): number {
  if (focusFileId) {
    const focused = history.findIndex((item) => item.fileId === focusFileId && !item.deleted);
    if (focused >= 0) return focused;
  }
  for (let i = history.length - 1; i >= 0; i--) {
    if (!history[i]?.deleted) return i;
  }
  return -1;
}
